(function ($) {
  "use strict";
  $(function () {
    if ($(".js-appointment-form").length === 0) {
      return;
    }

    $(".js-appointment-form").on("submit", function (e) {
      e.preventDefault();

      if (!$("#terms").is(":checked")) {
        alert("Kérjük fogadja el az adatkezelési tájékoztatót!");
        return false;
      }

      var $this = $(this);
      $this.find(".js-form-submit-button").prop("disabled", true);

      var formdata = $this.serializeArray();
      var successurl = $this.data("success-url");
      var captchaToken = $this.find("#g-recaptcha-response").val();

      if (!captchaToken) {
        alert("Kérjük töltse ki a reCaptcha mezőt!");
        $this.find(".js-form-submit-button").prop("disabled", false);
        return false;
      }

      $.ajax({
        url: localize.ajaxurl,
        type: "POST",
        data: {
          action: "contact_form",
          datas: formdata,
        },
        success: function (data) {
          var result = JSON.parse(data);
          var fields = [...new Set(result["fields"])];

          if (result["status"] == "success") {
            $this.trigger("reset");
            window.location.href = successurl;
          } else {
            $(fields).each(function (i, e) {
              if (e === "captcha") {
                alert("Kérjük töltse ki a reCaptcha mezőt!");
                return false;
              }
              $this
                .find(`[name=${e}]`)
                .closest(".field__item")
                .addClass("has--error");
            });
          }
        },
        error: function () {
          alert("Hiba történt az űrlap elküldése során, kérjük próbálja újra!");
        },
      }).done(function () {
        $this.find(".js-form-submit-button").prop("disabled", false);
      });
    });
  });
})(jQuery);
